var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg09Map(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.458,
    height: 27.448,
    viewBox: "0 0 35.458 27.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_452",
    "data-name": "Groupe 452",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_969",
    "data-name": "Trac\\xE9 969",
    d: "M2118.343,3935.67h-35.458l4.324-15.048h8.932v2.291h-7.207l-3.007,10.466H2115.3l-3.007-10.466h-6.75v-2.291h8.475Z",
    transform: "translate(-2082.885 -3908.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_970",
    "data-name": "Trac\\xE9 970",
    d: "M2104.091,3916.581a3.478,3.478,0,1,1-3.477-3.477,3.478,3.478,0,0,1,3.477,3.477",
    transform: "translate(-2082.885 -3908.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_971",
    "data-name": "Trac\\xE9 971",
    d: "M2100.614,3929.707l-.876-1.041c-.721-.857-7.043-8.484-7.043-12.525a7.919,7.919,0,1,1,15.838,0c0,4.041-6.322,11.668-7.043,12.525Zm0-19.194a5.635,5.635,0,0,0-5.628,5.628c0,2.154,3.16,6.859,5.628,9.975,2.468-3.117,5.628-7.824,5.628-9.975a5.635,5.635,0,0,0-5.628-5.628",
    transform: "translate(-2082.885 -3908.222)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg09Map);
export default __webpack_public_path__ + "static/media/09-map.2f61cd26df756b779f8d720566c1db43.svg";
export { ForwardRef as ReactComponent };